export const languageSelectId = 'languageSelect';
